import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const review: ImportTypeConfig = {
  type: 'review',
}
